import { PlanPdfPreviewView } from '@/views/authenticated/plans';
import { Role } from '@/const';
import { PlanOverviewView, PlanDocumentView } from '@/views/authenticated/plans/show';

export default [
  {
    path: '/municipalities/:municipality/plan/overview',
    name: 'app_plan_overview',
    meta: { title: 'Plan Overview' },
    component: PlanOverviewView,
  },
  {
    path: '/municipalities/:municipality/plan/document',
    name: 'app_plan_document',
    meta: {
      title: 'Plan Document',
      allowedRoles: [Role.MunicipalAdministrator, Role.IdpOfficer],
    },
    component: PlanDocumentView,
  },
  {
    path: '/municipalities/:municipality/plan/preview',
    name: 'app_plan_preview_document',
    // Must include `hideLayout` else the header (which includes the NavBar and footer will be shown in the preview)
    meta: {
      title: 'Plan Preview',
      hideLayout: true,
      requiresAuthentication: false,
    },
    component: PlanPdfPreviewView,
  },
];
